const tracesPath = [
  '/bond-screener/asset-backed-securities',
  '/bond-screener/corporate-bonds',
];

export default tracesPath;
